import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Row, Container, Col } from 'react-bootstrap';
import Loader from '../../../Components/Utility/Loader/Loader';
import UserLibraryFilter from './UserLibraryFilter';
import UserInstructionGroupCard from '../../../Components/Card/UserInstructionCard/UserInstructionGroupCard';
import { CareUserContext } from './provider/careUserContext';
import * as action from './store/UserInstruction.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';

export default function CareUserGroupListing() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const history = useHistory();
  const [subBrandAccess, setSubBrandAccess] = useState(false);

  const { state, setState, handleDeleteMultiple, getGroupTabs } = useContext(CareUserContext);
  const handleEdit = (id) => {
    history.push(`/libraries/care-user-group-instruction/edit/${id}`);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getGroupTabs();
      } catch (error) {
        console.error('Error fetching user instruction care group:', error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      const subBrandAccessRes = await dispatch(systemMasterAction.getSubBrandAccess());
      setSubBrandAccess(subBrandAccessRes?.data || false);
    };
    fetchSubBrandAccess();
  }, [dispatch]);

  const handleDeleteClick = async () => {
    const params = {
      id: state?.deleteId,
      rowId: state?.deleteId ? [state?.deleteId] : state?.selectedIds,
    };
    let res = false;
    if (state?.deleteId || state?.selectedIds?.length > 0) {
      res = await dispatch(action.deleteMultipleGroupAction(params?.rowId?.join(','), t));
    }
    if (res) {
      dispatch(action.clearTabReducer());
      await getGroupTabs();
    }

    setState((prevState) => ({
      ...prevState,
      deleteId: '',
      selectedIds: [],
      showConfirmationPopup: false,
    }));
  };

  const isChecked = (id) => {
    return Array.isArray(state?.selectedIds) && state?.selectedIds?.includes(id);
  };
  const handleGroupCardSelected = (id) => {
    let updatedSelectedIds;
    if (state?.selectedIds.includes(id)) {
      updatedSelectedIds = state?.selectedIds.filter((selectedId) => selectedId !== id);
    } else {
      updatedSelectedIds = [...state.selectedIds, id];
    }
    setState((prevState) => ({
      ...prevState,
      selectedIds: updatedSelectedIds,
    }));
    if (state?.onSelect) {
      setState((prevState) => ({
        ...prevState,
        selectedIds: updatedSelectedIds,
      }));
    }
  };
  const handleSelectAll = () => {
    const toggleSelectAll = !state?.selectAll;
    let allIds = [];
    if (toggleSelectAll) {
      allIds = state?.careUserGroupList?.map((data) => data?._id);
    }

    setState((prevIds) => ({
      ...prevIds,
      selectedIds: toggleSelectAll ? allIds : [],
      selectAll: toggleSelectAll,
    }));
  };
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.CARE_USER_GROUP_INSTRUCTION')}</h4>
        </div>
        <UserLibraryFilter selectedLibrary={state?.selectedIds} showButtons={false} fromGroup />
      </div>
      {state?.loading ? (
        <Loader />
      ) : (
        <Container className="care-group-container" fluid>
          <div className="d-flex justify-content-end care-container">
            <div className="common-checkbox">
              <input type="checkbox" id="check_selectAll" name="check_selectAll" checked={state?.selectAll} onChange={handleSelectAll} />
              <label htmlFor="check_selectAll" className="chklabel">
                <span className="text-bold">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SELECT')}</span>
              </label>
            </div>
          </div>
          <Row className="info-data-care">
            {Array?.isArray(state?.careUserGroupList) && state?.careUserGroupList?.length > 0 ? (
              state?.careUserGroupList?.map((dataItem) => (
                <UserInstructionGroupCard
                  dataItem={dataItem}
                  key={dataItem?._id}
                  handleEdit={() => handleEdit(dataItem?._id)}
                  handleDeleteMultiple={() => handleDeleteMultiple(dataItem?._id)}
                  handleGroupCardSelected={handleGroupCardSelected}
                  isChecked={isChecked}
                  subBrandAccess={subBrandAccess}
                />
              ))
            ) : (
              <div className="w-100 text-center">
                <Container fluid className="py-4">
                  <Row>
                    <Col md="12">
                      <p className="f-14 text-medium">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.NO_CARE_USER_INSTRUCTION_GROUP_FOUND')}</p>
                    </Col>
                  </Row>
                </Container>
              </div>
            )}
          </Row>
        </Container>
      )}
      {state?.showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={state?.showConfirmationPopup}
          toggle={() =>
            setState((prevState) => ({
              ...prevState,
              showConfirmationPopup: false,
              deleteId: '',
              selectedIds: [],
              isSelectAll: false,
              selectAll: false,
            }))
          }
          id={state?.deleteId}
          onConfirm={handleDeleteClick}
          title={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DELETE_GROUP')}
          message={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.GROUP_CONFIRMATION_MESSAGE')}
        />
      )}
    </>
  );
}
